// Authored as CommonJS so the API can `require` it; webpack in the React
// client handles the CommonJS → ESM interop transparently.



// -----------------------------------------------------------------------------
//   Enums
// -----------------------------------------------------------------------------


/**
 * Activity type tokens.
 * All user activities must be one of these.
 */
const activityTypes = Object.freeze({

  // ---------------------------------------------------------------------------
  //   User Auth
  // ---------------------------------------------------------------------------

  /** Successful user login. */
  USER_LOGGED_IN:        'USER_LOGGED_IN',

  /** Successful user logout. */
  USER_LOGGED_OUT:       'USER_LOGGED_OUT',

  /** User has accepted the Terms of Service. */
  USER_TOS_ACCEPTED:     'USER_TOS_ACCEPTED',


  // ---------------------------------------------------------------------------
  //   Video playback
  // ---------------------------------------------------------------------------

  USER_START_PLAYBACK:   'USER_START_PLAYBACK',
  USER_PAUSE_PLAYBACK:   'USER_PAUSE_PLAYBACK',

  /** User has started the video playback. */
  USER_START_RECORDING:  'USER_START_RECORDING',

  /** User has paused the video playback. */
  USER_PAUSED_RECORDING: 'USER_PAUSED_RECORDING',


  // ---------------------------------------------------------------------------
  //   Uploading
  // ---------------------------------------------------------------------------

  /** User has finished creating their recording. */
  USER_COMPLETED_VIDEO:  'USER_COMPLETED_VIDEO',

  /** The user has clicked to upload their recording. */
  USER_CLICK_UPLOAD:     'USER_CLICK_UPLOAD',

  /** The user has begun uploading their recording. */
  VIDEO_UPLOAD_START:    'VIDEO_UPLOAD_START',

  /** The user's upload process has completed. */
  VIDEO_UPLOAD_COMPLETE: 'VIDEO_UPLOAD_COMPLETE',

  /** The user's upload process has failed. */
  VIDEO_UPLOAD_FAILED:   'VIDEO_UPLOAD_FAILED',


  // ---------------------------------------------------------------------------
  //   Error States
  // ---------------------------------------------------------------------------


  /** The site is displaying an error state to the user. */
  ENTERED_ERROR_STATE:   'ENTERED_ERROR_STATE',

});



// -----------------------------------------------------------------------------
//   Export(s)
// -----------------------------------------------------------------------------

module.exports = { activityTypes };
